import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  initialize() {
    this.onUpdate = this.onUpdate.bind(this)
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      ghostClass: 'ghost'
    })
  }

  onUpdate(event) {
    let id = event.item.dataset.id
    let position = event.newIndex + 1

    let data = new FormData()
    data.append("position", position)

    fetch(this.data.get("url").replace(":id", id), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      },
      data: data
    }).then();
  }

  disconnect() {
    this.sortable.destroy()
    this.sortable = undefined
  }
}
